import axios from './axios'
import axios1 from './axio1s'
const apiAdmin = {
  // 1. 首页
  // 1.1 首页最近打开最近常用
  getList: (data) => {
    return axios('/Home/Article/Getuseinfo', data)
  },
  // 1.2 首页热门模板
  getHOtList: (data) => {
    return axios('/Home/Article/GetHot', data)
  },
  // 2. 模板中心
  // 2.1 自有模板列表
  GetMyArt: (data) => {
    return axios('/Home/Article/GetMyArt', data)
  },

  // 2.2 系统模板列表
  GetsystemArt1: (data) => {
    return axios('/Home/Article/GetsystemArt', data)
  },
  // 智能成稿素材搜索
  GetsystemArt: (data) => {
    return axios('/Home/Article/GetSucai', data)
  },
  // 2.3 模板文章详情
  Viemoban: (data) => {
    return axios('/Home/Article/Viewmoban', data)
  },
  // 2.4 模板文章饮用量+1
  useinfo: (data) => {
    return axios('/Home/Article/useinfo', data)
  },
  // 2.5 系统模板分类
  Getkind: (data) => {
    return axios('/Home/Folder/Getkind', data)
  },
  // 2.6 修改自有模板
  Editmoban: (data) => {
    return axios('/Home/Article/Editmoban', data)
  },
  // 2.7 删除自有模板
  DelMoban: (data) => {
    return axios('/Home/Article/DelMoban', data)
  },
  // 3.我的文章
  // 3.1 创建文件夹
  AddFolder: (data) => {
    return axios('/Home/Folder/AddFolder', data)
  },
  // 3.2 删除文件夹
  DelFolder: (data) => {
    return axios('/Home/Folder/DelFolder', data)
  },
  // 3.3 我的文件夹列表
  GetFolderList: (data) => {
    return axios('/Home/Folder/GetFolderList', data)
  },
  // 3.4 我的文件夹里文章列表
  GetMyArticle: (data) => {
    return axios('/Home/Article/GetMyArticle', data)
  },
  // 3.5 标签列表
  GetAllLable: (data) => {
    return axios('/Home/Lable/GetAllLable', data)
  },
  // 3.6 自己写的文章详情
  viewArticle: (data) => {
    return axios('/Home/Article/View', data)
  },
  // 3.7 自己写的文章删除
  delArticle: (data) => {
    return axios('/Home/Article/Del', data)
  },
  // 3.8 自c己写的文章复制
  copyArticle: (data) => {
    return axios('/Home/Article/Copy', data)
  },
  // 4. 智能成稿
  // 4.1 自己添加标签接口
  AddLable: (data) => {
    return axios('/home/Lable/AddLable', data)
  },
  // 4.2 删除标签接口
  DelLable: (data) => {
    return axios('/home/Lable/DelLable', data)
  },
  // 4.3 添加文章
  addArticle: (data) => {
    return axios('/Home/Article/Add', data)
  },
  // 4.4 编辑文章
  editArticle: (data) => {
    return axios('/Home/Article/edit', data)
  },
  // 4.5 生成模板
  Addmoban: (data) => {
    return axios('/Home/Article/Addmoban', data)
  },
  // 4.6 获取所有标签
  AllLable: (data) => {
    return axios('/Home/Lable/GetAllLable', data)
  },
  // 4.7 本地导入文章
  WordLocal: (data) => {
    return axios('/home/readword/WordLocal', data, 'post', false)
  },
  ///
  // 4.8 获取知识库里面的文件
  GetAllFile: (data) => {
    return axios('Home/Api/GetAllFile', data)
  },
  // 4.8 知识库导入文章
  wordread: (data) => {
    return axios1('/home/readword/wordread', data)
  },
  // 5. 回收站
  // 5.1 回收站列表
  GetRecycleBin: (data) => {
    return axios('/Home/Article/GetRecycleBin', data)
  },
  // 5.2 回收站3一键清空、1还原、2删除
  RecycleBinDo: (data) => {
    return axios('/Home/Article/RecycleBinDo', data)
    // return axios('/Home/Article/RecycleBinDo_new', data)
  },
  // 6. 帮助中心
  GetHelpinfo: (data) => {
    return axios('/Home/Index/GetHelpinfo', data)
  },
  // 7. 帐号管理
  // 7.1 个人信息
  Getinfo: (data) => {
    return axios('/Home/User/Getinfo', data)
  },
  // 7.2 修改个人信息
  Editinfo: (data) => {
    return axios('/Home/User/Editinfo', data)
  },
  // 7.3 修改手机号
  Changephone: (data) => {
    return axios('/Home/User/Changephone', data)
  },
  // 7.3 修改密码
  ChangePass: (data) => {
    return axios('/Home/User/ChangePass', data)
  },
  // 7.4 微信解绑
  DelWechat: (data) => {
    return axios('/Home/User/DelWechat', data)
  },
  // 编辑器图片上传
  file: (data) => {
    return axios('/Home/Index/imgupload', data, 'post', false)
  },
  // 头像上传
  headfile: (data) => {
    return axios('/Home/Index/imgthumb', data, 'post', false)
  },
  // 验证手机号
  checkphone: (data) => {
    return axios('/Home/User/checkphone', data)
  },
  // 最新文章
  ArticleList: (data) => {
    return axios('/Home/Article/ArticleList', data)
  },
  // 首页接口两个
  useoften: (data) => {
    return axios('/Home/Article/useoften', data)
  },
  // 导出知识库
  GetAllFolder: (data) => {
    return axios('/Home/Api/GetAllFolder', data)
  },
  // 导出知识库
  WordLocal1: (data) => {
    return axios1('/home/readword/WordLocal', data,'post', false)
  },
  // 消息中心
  Message: (data) => {
    return axios('/Home/message/index', data)
  },
  // 消息详情
  MessageDetail: (data) => {
    return axios('/home/message/detail', data)
  },
  // 易书宝我的文章自建创建文件夹目录结构
  ApiFolderList: (data) => {
    return axios('/Home/Api/GetFolderList', data)
  },
  // 批量导入新建库文件夹
  ApiAddFolder: (data) => {
    return axios('/Home/Api/AddFolder', data)
  },
  // 批量导入新建库文件夹(带文件夹)
  ExportMore: (data) => {
    return axios('/Home/Api/ExportMore', data)
  },
  // 批量导入新建库文件夹(不带文件夹)
  Export: (data) => {
    return axios('/Home/Api/Export', data)
  },
  worddown: (data) => {
    return axios('/home/article/worddown', data)
  },
}
export default apiAdmin
